import GatewayApiClient from '../clients/gateway-api/gateway-api.client';
import { useQuery } from '@tanstack/react-query';
import { queryClient } from '../query-client';

type DataMap = { [key: string]: string };
type Props = {
  onSuccess?: (data: DataMap) => void;
};

export const prefetchUnderlyingsMap = async ({ onSuccess }: Props) => {
  return queryClient.prefetchQuery({
    queryKey: ['underlyings-map'],
    queryFn: async () => {
      const data = await GatewayApiClient.getUnderlyingSymbolChanges();

      onSuccess?.(data as DataMap);
      return data;
    },
  });
};

export const useUnderlyingsMap = ({ onSuccess }: Props) => {
  return useQuery({
    queryKey: ['underlyings-map'],
    queryFn: async () => {
      const data = await GatewayApiClient.getUnderlyingSymbolChanges();

      return data;
    },
    persister: async (queryFn, context, query) => {
      const data = await queryFn(context);

      onSuccess?.(data as DataMap);

      return data;
    },
  });
};
